import React, { useRef } from "react";
import "./Contact.css";
import { MdLocationOn, MdArrowDownward } from "react-icons/md";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_4ce0hui",
        "template_v8zzoxm",
        form.current,
        "Uu_0uIq3kVHj8K6dD"
      )
      .then(
        () => {
          console.log("SUCCESS!");
          e.target.reset();
          alert("Email Sent!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <section id="contactPage">
    <div className="contactUs">
      <div className="contactInfo">
        <h2 className="contactHeading">CONNECT WITH US</h2>
        <div className="contactDetails">
          <p className="phoneNumber">
            <strong>Phone:</strong>
          </p>
          <ul className="numberList">
            <li>
              <FaPhoneAlt className="contactIcon" />
              +254 733 823 277
            </li>
            <li>
              <FaPhoneAlt className="contactIcon" />
              +254 713 473 009
            </li>
          </ul>
          <p className="emailAddress">
            <strong>Email Address:</strong>
          </p>
          <ul className="emailList">
            <li>
              <FaEnvelope className="contactIcon" />
              deltacoolingsystemsltd@gmail.com
            </li>
            <li>
              <FaEnvelope className="contactIcon" />
              delta.cooling@yahoo.com
            </li>
            <li>
              <FaEnvelope className="contactIcon" />
              info@deltacooling.co.ke
            </li>
          </ul>
          <p className="website">
            <strong>Website:</strong>
          </p>
          <p>
            <FaGlobe className="contactIcon" />
            <a href="http://www.deltacooling.co.ke" className="web-link">
              www.deltacooling.co.ke
            </a>
          </p>
        </div>
        <div className="contact-Location">
          <h3>Office Location</h3>
          <p>GODOWN NO.4 NEXT TO UNIPRO,</p>
          <p>ROAD C BEHIND VISION PLAZA,</p>
          <p>OFF MOMBASA ROAD,</p>
          <p>P.O BOX 12915 – 00100,</p>
          <p>NAIROBI - KENYA.</p>
        </div>
      </div>
      <div className="contactForm">
        <form className="contactFrm" ref={form} onSubmit={sendEmail}>
          <label htmlFor="fullName" className="form-label">
            Full Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Your Name"
            name="your_name"
            required
          />
          <label htmlFor="phone" className="form-label">
            Phone
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="+254 733 823 277"
            name="phone_number"
            required
          />
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            placeholder="example@email.com"
            name="your_email"
            required
          />
          <label htmlFor="message" className="form-label">
            Message
          </label>
          <textarea
            className="form-control"
            name="message"
            rows="6"
            placeholder="Type your message here"
            required
          ></textarea>
          <div className="submit">
            <button className="submitBtn" type="submit">
              <span>Send Message</span>
            </button>
          </div>
        </form>
      </div>
    </div>
      <div className="mapLocation">
          <a
            href="https://www.google.com/maps/dir/-1.2458948,36.8949213/Delta+Cooling+Systems+Limited/data=!4m10!4m9!1m1!4e1!1m5!1m4!1s0x182f11ec9567fdd3:0xbc76af47f3ae2259!8m2!3d-1.3267605!4d36.8532436!3e0"
            target="_blank"
            rel="noopener noreferrer"
            className="direction-link"
          >
            <div className="locationIconMain">
              <MdLocationOn className="locationIcon1" />
              <MdArrowDownward className="locationIcon2" />
            </div>
            <p>Click For Directions</p>
          </a>
          {/* Embed Google Map iframe to show the route */}
          <iframe
            title="Google Map of Delta Cooling Systems"
            src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d31860.0466287245!2d36.8949213!3d-1.2458948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x0%3A0x0!2zLTFsIDI0JzM1LjIiUyAzNsKwNTMnNDMuNyJF!3m2!1d-1.2458948!2d36.8949213!4m5!1s0x182f11ec9567fdd3%3A0xbc76af47f3ae2259!2sDelta%20Cooling%20Systems%20Limited!3m2!1d-1.3267605!2d36.8532436!5e0!3m2!1sen!2ske!4v1695200000000"
            width="95%"
            height="400px"
            style={{ border: 0, 
                     borderRadius: '15px',
                     overflow: 'hidden' 
             }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
    </section>
  );
};

export default Contact;
